// extracted by mini-css-extract-plugin
export var divider = "_mg-0";
export var labelWrapper = "_mg-2";
export var lineSvg = "_mg-1";